// frontend/src/components/account/InvoiceDetailModal.jsx
import { Modal, Space, Descriptions, Table, Button, Spin, Typography } from "antd";
import { LinkOutlined, DownloadOutlined } from "@ant-design/icons";
import InvoiceStatusTag from "./InvoiceStatusTag";
import { formatDate } from "../utils/invoiceUtils";

const { Title, Text } = Typography;

const InvoiceDetailModal = ({
  invoiceModalVisible,
  setInvoiceModalVisible,
  setSelectedInvoiceId,
  invoiceDetails,
  loadingInvoiceDetails,
  isDownloading,
  selectedInvoiceId,
  handleViewOnStripe,
  handleDownload,
}) => {
  return (
    <Modal
      title={
        <Space>
          <Title level={4} style={{ margin: 0 }}>
            Invoice #{invoiceDetails?.invoice?.number || ""}
          </Title>
          {invoiceDetails?.invoice?.status && (
            <InvoiceStatusTag status={invoiceDetails.invoice.status} />
          )}
        </Space>
      }
      open={invoiceModalVisible}
      onCancel={() => {
        setInvoiceModalVisible(false);
        setSelectedInvoiceId(null);
      }}
      footer={[
        <Button
          key="view"
          icon={<LinkOutlined />}
          onClick={() => handleViewOnStripe(invoiceDetails?.invoice?.hostedInvoiceUrl)}
          disabled={!invoiceDetails?.invoice?.hostedInvoiceUrl}
        >
          View on Stripe
        </Button>,
        <Button
          key="download"
          type="primary"
          icon={isDownloading ? <Spin size="small" /> : <DownloadOutlined />}
          onClick={() => handleDownload(selectedInvoiceId)}
          disabled={isDownloading || !invoiceDetails?.invoice?.pdfUrl}
          style={{ backgroundColor: "#6DB33F", borderColor: "#6DB33F" }}
        >
          {isDownloading ? "Downloading..." : "Download PDF"}
        </Button>,
      ]}
      width={800}
      style={{ top: 20 }}
    >
      {loadingInvoiceDetails ? (
        <div style={{ textAlign: "center", padding: 50 }}>
          <Spin size="large" />
        </div>
      ) : invoiceDetails?.invoice ? (
        <div>
          <Descriptions bordered column={2} size="small">
            <Descriptions.Item label="Customer">
              {invoiceDetails.invoice.customerName}
            </Descriptions.Item>
            <Descriptions.Item label="Email">
              {invoiceDetails.invoice.customerEmail}
            </Descriptions.Item>
            <Descriptions.Item label="Date">
              {formatDate(invoiceDetails.invoice.created)}
            </Descriptions.Item>
            <Descriptions.Item label="Due Date">
              {formatDate(invoiceDetails.invoice.dueDate)}
            </Descriptions.Item>
            <Descriptions.Item label="Total Amount" span={2}>
              <Text strong style={{ fontSize: 16, color: "#2D5016" }}>
                {invoiceDetails.invoice.currency} {invoiceDetails.invoice.amount.toFixed(2)}
              </Text>
            </Descriptions.Item>
            <Descriptions.Item label="Amount Paid" span={2}>
              {invoiceDetails.invoice.currency} {invoiceDetails.invoice.amount_paid.toFixed(2)}
            </Descriptions.Item>
          </Descriptions>

          <div style={{ marginTop: 24 }}>
            <Title level={5}>Invoice Items</Title>
            <Table
              columns={[
                { title: "Description", dataIndex: "description", key: "description" },
                { title: "Quantity", dataIndex: "quantity", key: "quantity", align: "center" },
                {
                  title: "Amount",
                  dataIndex: "amount",
                  key: "amount",
                  align: "right",
                  render: (amount) => (
                    <Text strong>
                      {invoiceDetails.invoice.currency} {amount.toFixed(2)}
                    </Text>
                  ),
                },
              ]}
              dataSource={invoiceDetails.invoice.lines?.map((line, index) => ({
                key: index,
                description: line.description,
                quantity: line.quantity,
                amount: line.amount,
              })) || []}
              pagination={false}
              size="small"
              summary={(pageData) => {
                let total = 0;
                pageData.forEach(({ amount }) => { total += amount; });
                return (
                  <Table.Summary fixed>
                    <Table.Summary.Row>
                      <Table.Summary.Cell index={0} colSpan={2}>
                        <Text strong>Total</Text>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={2} align="right">
                        <Text strong>
                          {invoiceDetails.invoice.currency} {invoiceDetails.invoice.amount.toFixed(2)}
                        </Text>
                      </Table.Summary.Cell>
                    </Table.Summary.Row>
                  </Table.Summary>
                );
              }}
            />
          </div>
        </div>
      ) : null}
    </Modal>
  );
};

export default InvoiceDetailModal;